import React from 'react';

function EmptyState({ icon, title, description, action }) {
  return (
    <div style={{ textAlign: 'center', padding: '48px 24px' }}>
      {icon && <div style={{ fontSize: '32px', color: 'var(--admin-text-muted)', marginBottom: '12px', opacity: 0.4 }}><i className={icon} /></div>}
      <h3 style={{ color: 'var(--admin-text-primary)', fontSize: '15px', fontWeight: '600', margin: '0 0 6px' }}>{title}</h3>
      {description && <p style={{ color: 'var(--admin-text-secondary)', fontSize: '13px', margin: '0 0 16px', maxWidth: '360px', marginLeft: 'auto', marginRight: 'auto' }}>{description}</p>}
      {action}
    </div>
  );
}

export default EmptyState;
